export const callbackUri =
  typeof window !== 'undefined' ? window.location.origin : ''
// AUTH0
export const AUTH0_SECRET = process.env['AUTH0_SECRET'] || ''
export const AUTH0_COOKIE_DOMAIN = process.env['AUTH0_COOKIE_DOMAIN']
export const AUTH0_ISSUER_BASE_URL = process.env['AUTH0_ISSUER_BASE_URL']
export const AUTH0_ISSUER_BASE_BUILDER =
  (process.env['AUTH0_ISSUER_BASE_BUILDER'] || 'auth.dev.flecto.io') ?? ''
export const AUTH0_TENANT_DOMAIN =
  process.env['AUTH0_TENANT_DOMAIN'] || 'rnters-dev.eu.auth0.com'
export const AUTH0_CLIENT_ID =
  process.env['AUTH0_CLIENT_ID'] || '2P2Uc0VdmJmPYZApHruUD3evzYeLF6LL'
export const AUTH0_CONNECTION = 'Username-Password-Authentication'
export const AUTH0_AUDIENCE = process.env['AUTH0_AUDIENCE']
export const AUTH0_SCOPE = 'openid profile email update:current_user_identities'
export const AUTH0_RESPONSE_TYPE = 'token id_token'
export const AUTH0_RESPONSE_MODE = 'form_post'
export const AUTH0_CLIENT_SECRET = process.env.AUTH0_CLIENT_SECRET
export const API_URL = process.env['API_URL']

export const domain = AUTH0_ISSUER_BASE_URL
export const clientId = AUTH0_CLIENT_ID
export const auth0Domain = AUTH0_ISSUER_BASE_URL

function addHttpsIfNeeded(url?: string) {
  if (!url) return null
  if (url.startsWith('http')) {
    return url
  }
  return `https://${url}`
}

export const SITE_URL =
  process.env['NEXT_PUBLIC_SITE_URL'] ||
  addHttpsIfNeeded(process.env['NEXT_PUBLIC_VERCEL_BRANCH_URL']) ||
  'https://app.dev.flecto.io:8888'
